import axios from 'axios'

// URL base das requests
const baseURL = process.env.REACT_APP_API

/** Instancia API */ 
var api = axios.create({
    baseURL
})

/** INTERCEPTORS DA REQUEST */
api.interceptors.request.use(async config => {
    const token = localStorage.getItem('token')
    if( token ) config.headers.authorization = token
    config.headers['Access-Control-Allow-Origin'] = "*"
    return config
})

api.interceptors.response.use( (res) => { 
        // console.log('RES *****')
        // console.log(res)
        // console.log('RES *****')
        return res
    }, (error) => {
    // console.log('response', JSON.stringify(error)   )
    // console.log('response',    error.request)

    if (error.response != undefined && error.request.responseType === 'arraybuffer' && error.response.data.toString() === '[object ArrayBuffer]') 
        error = JSON.parse(Buffer.from(error.response.data).toString('utf8'))   

    return Promise.reject(error)
})
export default api
